import { httpClient } from '@/lib/http/http-client'
import type {
  ChangePasswordRequestDto,
  ConfirmEmailChangeRequestDto,
  CurrentUserDto,
  EmailChangeRequestDto,
  EmailChangeResponseDto,
  ForgotPasswordRequestDto,
  LoginRequestDto,
  SetPasswordRequestDto,
  UpdateMeRequestDto,
} from '@/types/auth/auth.types'
import type { GeneralSuccessDto } from '@/types/configuration/variables.types'

const RESOURCE = '/auth'

export const authApi = {
  login: (payload: LoginRequestDto) =>
    httpClient.post<CurrentUserDto>(`${RESOURCE}/login`, { json: payload }),

  logout: () => httpClient.post<GeneralSuccessDto>(`${RESOURCE}/logout`),

  me: (signal?: AbortSignal) =>
    httpClient.get<CurrentUserDto>(`${RESOURCE}/me`, { signal }),

  updateMe: (payload: UpdateMeRequestDto) =>
    httpClient.patch<CurrentUserDto>(`${RESOURCE}/me`, { json: payload }),

  forgotPassword: (payload: ForgotPasswordRequestDto) =>
    httpClient.post<GeneralSuccessDto>(`${RESOURCE}/password/forgot`, { json: payload }),

  /** 200 while the link can still set a password, 404 once it cannot. */
  validatePasswordLink: (token: string, signal?: AbortSignal) =>
    httpClient.get<GeneralSuccessDto>(`${RESOURCE}/password/validate`, {
      searchParams: { token },
      signal,
    }),

  setPassword: (payload: SetPasswordRequestDto) =>
    httpClient.post<GeneralSuccessDto>(`${RESOURCE}/password/set`, { json: payload }),

  changePassword: (payload: ChangePasswordRequestDto) =>
    httpClient.post<GeneralSuccessDto>(`${RESOURCE}/password/change`, { json: payload }),

  requestEmailChange: (payload: EmailChangeRequestDto) =>
    httpClient.post<EmailChangeResponseDto>(`${RESOURCE}/email/change`, {
      json: payload,
    }),

  confirmEmailChange: (payload: ConfirmEmailChangeRequestDto) =>
    httpClient.post<GeneralSuccessDto>(`${RESOURCE}/email/change/confirm`, {
      json: payload,
    }),
}
